<template>
  <b-tab
    title="Faturamento"
    @click="() => (store.currentTab = 5)"
    :active="isTheCurrentTab"
    :disabled="!isTheCurrentTab && !store.isUpdate"
  >
    <b-row align-h="center">
      <b-col md="8">
        <!-- VALOR BASE -->
        <b-row>
          <b-col>
            <b-form-group label="Valor R$" label-for="valorPagamento">
              <money
                class="form-control"
                :key="keyToReRender"
                id="valorPagamento"
                name="valorPagamento"
                :value="valorPagoARealizar"
                @input="onInputValue"
                v-bind="configMask"
                :class="{
                  hasErrorsValor: valorError,
                  inputFilledvalor: valorFilled,
                }"
                :disabled="hasNoProductsOrServices"
              ></money>
            </b-form-group>
          </b-col>
        </b-row>

        <!-- DESCONTO COM R$/% -->
        <b-row>
          <b-col>
            <b-form-group label="Desconto" label-for="valorDesconto">
              <b-input-group>
                <!-- R$ -->
                <money
                  v-if="form.desconto_tipo === 'valor'"
                  :key="'desconto-valor-' + keyToReRender"
                  class="form-control"
                  id="valorDesconto"
                  name="valorDesconto"
                  v-model="form.desconto"
                  v-bind="configMask"
                  :disabled="hasNoProductsOrServices"
                ></money>

                <!-- % -->
                <b-form-input
                  v-else
                  :key="'desconto-percentual-' + keyToReRender"
                  type="number"
                  min="0"
                  max="100"
                  step="0.01"
                  v-model.number="form.desconto"
                  class="form-control"
                  :disabled="hasNoProductsOrServices"
                  placeholder="0,00"
                ></b-form-input>

                <b-input-group-append>
                  <b-button variant="light" @click="toggleTipoDesconto">
                    {{ form.desconto_tipo === "valor" ? "R$" : "%" }}
                  </b-button>
                </b-input-group-append>
              </b-input-group>
              <small
                v-if="form.desconto_tipo === 'percentual'"
                class="text-muted"
              >
                Será aplicado sobre o total (produtos + serviços).
              </small>
            </b-form-group>
          </b-col>
        </b-row>

        <!-- FORMA PAGAMENTO -->
        <b-row>
          <b-col>
            <b-form-group
              label="Forma de Pagamento"
              label-for="forma_pagamento"
            >
              <VueSelect
                :key="keyToReRender"
                ref="buscar_forma_pagamento"
                :filterable="false"
                :options="formas_pagamento"
                :disabled="valorPagoARealizar === 0 || hasNoProductsOrServices"
                @search="onSearchFormaPagamentos"
                @input="setFormaPagamento"
                v-model="formaPagamento"
                :class="{
                  hasErrors: pagamentoError,
                  inputFilled: pagamentoFilled,
                }"
              >
                <template slot="no-options"
                  >Seleciona a forma de pagamento</template
                >
                <template slot="option" slot-scope="option">
                  <div class="d-center">{{ option.descricao }}</div>
                </template>
                <template slot="selected-option" slot-scope="option">
                  <div class="selected d-center">{{ option.descricao }}</div>
                </template>
              </VueSelect>
            </b-form-group>
          </b-col>
        </b-row>

        <!-- PARCELAS GERADAS -->
        <b-row>
          <b-col>
            <TableApp
              item="pagamento"
              :data="pagamento"
              :fields="fields"
              classFilterColumn="valor"
              ref="valor"
              :key="keyToReRender"
            >
              <template slot="customRow" scope="props">
                <span v-if="props.field == 'id'">
                  <div class="d-flex align-items-center">
                    <div class="font-weight-bold text-muted">
                      {{ props.rowData.originalIndex + 1 }}
                    </div>
                  </div>
                </span>
                <span v-if="props.field == 'valor'">
                  <div class="d-flex align-items-center">
                    <div
                      v-b-modal.modal-pagamento
                      @click="changePagamento(props.rowData.originalIndex)"
                      class="font-weight-bold text-muted cursor-pointer"
                    >
                      {{ numberToReal(props.rowData.valor, 2) }}
                    </div>
                  </div>
                </span>
                <span v-if="props.field == 'vencimento'">
                  <div class="d-flex align-items-center">
                    <div
                      v-b-modal.modal-calendar
                      class="font-weight-bold text-muted cursor-pointer"
                      @click="selectVencimento(props.rowData.originalIndex)"
                    >
                      {{ props.rowData.vencimento | moment("DD/MM/YYYY") }}
                    </div>
                  </div>
                </span>
              </template>
            </TableApp>
          </b-col>
        </b-row>

        <!-- ADD PAGAMENTO -->
        <b-row>
          <button
            ref="submit_novo_pagamento123"
            class="btn btn-secondary font-weight-bold"
            @click="addPagamento"
            :disabled="isAllInputsNotFull"
          >
            + Adicionar Pagamento
          </button>
        </b-row>
      </b-col>
    </b-row>

    <!-- TOTAL / A PAGAR -->
    <b-row align-h="center">
      <b-col md="8">
        <b-row class="d-flex flex-row-reverse px-10">
          <div class="d-flex flex-column text-md-right">
            <span class="font-size-lg font-weight-bolder mb-1">A PAGAR</span>
            <span
              class="font-size-h2 font-weight-boldest mb-1"
              :key="keyToReRender + 1"
            >
              R$ {{ numberToReal(subtotal, 2) }}
            </span>
            <span class="text-success" :key="keyToReRender">
              Valor Pago: R$ {{ numberToReal(valorPago, 2) }}
            </span>
          </div>
        </b-row>
      </b-col>
    </b-row>

    <!-- LISTA DE PAGAMENTOS FINAL -->
    <b-row align-h="center">
      <b-col md="8">
        <TableApp
          :key="keyToReRender"
          class="mt-10"
          item="pagamento"
          titulo="Pagamentos"
          :data="form.pagamentos"
          :fields="fieldsPagamentosRealizados"
          classFilterColumn="formaPagamento"
          ref="formaPagamento"
        >
          <template slot="customRow" scope="props">
            <span v-if="props.field == 'forma_pagamento'">
              <div class="d-flex align-items-center">
                <div class="font-weight-bold text-muted">
                  {{ props.rowData.forma_pagamento.descricao }}
                </div>
              </div>
            </span>
            <span v-if="props.field == 'valor'">
              <div class="d-flex align-items-center">
                <div class="font-weight-bold text-muted">
                  R$ {{ numberToReal(props.rowData.valor) }}
                </div>
              </div>
            </span>
            <span v-if="props.field == 'actions'">
              <div class="row-actions" style="text-align: right !important">
                <div class="action-buttons">
                  <button
                    @click="
                      removePagamento(
                        props.rowData,
                        props.rowData.originalIndex
                      )
                    "
                    class="btn btn-sm btn-danger btn-hover-danger btn-icon mr-2"
                  >
                    <TrashCanIcon :size="16" />
                  </button>
                </div>
              </div>
            </span>
          </template>
        </TableApp>
      </b-col>
    </b-row>

    <!-- MODAL VENCIMENTO -->
    <b-modal id="modal-calendar" title="Ajustar vencimento" size="sm" centered>
      <div class="mx-auto">
        <b-calendar v-model="vencimentoSelected" locale="pt-BR"></b-calendar>
      </div>
      <template #modal-footer="{ cancel }">
        <b-button @click="cancel()">Cancelar</b-button>
        <b-button variant="primary" @click="salvarVencimento">Salvar</b-button>
      </template>
    </b-modal>

    <!-- MODAL AJUSTE PAGAMENTO -->
    <b-modal id="modal-pagamento" title="Ajustar pagamento" size="sm" centered>
      <div class="mx-auto">
        <b-form class="form" @submit.stop.prevent="salvarPagamento">
          <money
            @input="changePagamentoEdited"
            class="form-control"
            id="valorPagamento"
            name="valorPagamento"
            :value="valorPagamento"
            v-bind="configMask"
          ></money>
        </b-form>
      </div>
      <template #modal-footer="{ cancel }">
        <b-button @click="cancel()">Cancelar</b-button>
        <b-button variant="primary" @click="salvarPagamento">Salvar</b-button>
      </template>
    </b-modal>
  </b-tab>
</template>

<script>
import { mapGetters, mapState, mapActions } from "vuex";
import VueSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import { validationMixin } from "vuelidate";
import FaturamentoData, { FaturamentoDataRequired } from "../FaturamentoData";
import TrashCanIcon from "vue-material-design-icons/TrashCan.vue";
import TableApp from "../../../../components/Table/Table3.vue";
import {
  SistemaMixin,
  ValidacaoMixin,
  InstallmentsMixin,
} from "@/modules/Application";
import _ from "lodash";
import { mask } from "vue-the-mask";
import { Money } from "v-money";
import { MONEY as settingMoney } from "@/modules/Application";
import { store } from "../../storeOS";
import moment from "moment";

export default {
  name: "app-orcamento-form-faturamentoTab",
  components: {
    VueSelect,
    Money,
    TableApp,
    TrashCanIcon,
  },
  directives: { mask },
  data() {
    return {
      store,
      form: {
        desconto: 0,
        desconto_tipo: "valor", // 'valor' | 'percentual'
        pagamentos: [],
      },
      vencimento: [],
      configMask: settingMoney,
      categorias: [],
      contas: [],
      vencimentoSelected: null,
      indexVencimento: null,
      fromEdit: false,
      pagamento: [],
      formas_pagamento: [],
      formasPagamentoArray: [],
      pagamentosEditados: [],
      plano_contas: [],
      selectedPagamento: null,
      keyToReRender: 0,
      fieldsPagamentosRealizados: [
        { label: "", field: "forma_pagamento", slot: true, width: "45%" },
        { label: "", field: "valor", slot: true, width: "45%" },
        { label: "", field: "actions", slot: true, width: "10%" },
      ],
      fields: [
        { label: "", field: "id", slot: true, width: "10%" },
        { label: "Valor R$", field: "valor", slot: true, width: "45%" },
        { label: "Vencimento", field: "vencimento", slot: true, width: "45%" },
      ],
      subtotal: 0,
      valorPagoARealizar: 0,
      valorPago: 0,
      formaPagamento: null,
      planoConta: null,
      openChangeVencimentoModal: false,
      informacoesAdicionais: "",
      pagamentoEditado: 0,
      valorError: false,
      valorFilled: false,
      pagamentoError: false,
      pagamentoFilled: false,
      planoContasError: false,
      planoContasFilled: false,
      applyingStoreForm: false,
    };
  },
  mixins: [validationMixin, SistemaMixin, ValidacaoMixin, InstallmentsMixin],
  validations: { form: FaturamentoDataRequired },
  methods: {
    ...mapActions(["setLoading"]),

    async getDataInit() {
      this.form = new FaturamentoData({});
      // garante que existe
      if (!this.form.desconto_tipo) this.form.desconto_tipo = "valor";
      if (!this.form.pagamentos) this.form.pagamentos = [];
      this.vencimentoSelected = this.thisDate();
      this.formas_pagamento = await this.getFormasPagamentos();
      this.formasPagamentoArray = this.formas_pagamento;
      this.plano_contas = await this.getPlanoContas(2);
      this.planoConta = this.plano_contas.find(
        (plano) => plano.descricao === "Venda de Produtos"
      );

      if (this.temPagamentosNaStore()) {
        this.aplicarFormPagamentosDaStore(this.store.formPagamentos);
        return;
      }

      const total = this.getTotalProdutosEServicos();
      const valorDesconto = this.calcularValorDesconto();
      this.subtotal = this.round(total - valorDesconto, 2);
      this.valorPagoARealizar = this.round(total, 2);

      // se não tem nada pra cobrar, deixa sem pagamentos
      if (this.hasNoProductsOrServices) {
        this.form.pagamentos = [];
        this.valorPago = 0;
      }

      this.syncFormWithStore();
    },

    // sempre manda desconto em R$ pro store
    syncFormWithStore() {
      if (this.applyingStoreForm) {
        return;
      }

      // Evita sobrescrever pagamentos da store (ex.: importados de orçamento)
      // quando o form local ainda está vazio — isso acontece quando watchers
      // de produtos/serviços disparam antes do watcher de pagamentos durante
      // uma importação, causando a perda dos pagamentos.
      const storeTemPagamentos =
        Array.isArray(this.store.formPagamentos?.pagamentos) &&
        this.store.formPagamentos.pagamentos.length > 0;

      const formTemPagamentos =
        Array.isArray(this.form.pagamentos) && this.form.pagamentos.length > 0;

      if (storeTemPagamentos && !formTemPagamentos && !this.fromEdit) {
        return;
      }

      const descontoEmReais = this.calcularValorDesconto();
      this.store.formPagamentos = {
        ...this.store.formPagamentos,
        pagamentos: this.form.pagamentos || [],
        desconto: descontoEmReais, // sempre R$
        desconto_tipo: this.form.desconto_tipo || "valor",
      };
    },

    temPagamentosNaStore() {
      return (
        Array.isArray(this.store.formPagamentos?.pagamentos) &&
        this.store.formPagamentos.pagamentos.length > 0
      );
    },

    aplicarFormPagamentosDaStore(newValue) {
      this.applyingStoreForm = true;
      this.form = {
        ...this.form,
        ...newValue,
        pagamentos: newValue.pagamentos || [],
        desconto: newValue.desconto ?? 0,
        desconto_tipo: newValue.desconto_tipo || "valor",
      };

      const total = this.getTotalProdutosEServicos();
      const valorDesconto = this.calcularValorDesconto();
      this.valorPago = this.form.pagamentos.reduce(
        (acc, p) => this.round(acc + Number(p.valor || 0), 2),
        0
      );
      this.subtotal = this.round(total - valorDesconto - this.valorPago, 2);
      this.valorPagoARealizar = this.round(
        this.subtotal > 0 ? this.subtotal : 0,
        2
      );
      this.formaPagamento = this.form.pagamentos[0]?.forma_pagamento || null;
      this.pagamento = (this.form.pagamentos[0]?.range || []).map(
        (parcela) => ({
          vencimento: parcela.date,
          valor: Number(parcela.value || 0),
        })
      );
      this.vencimentoSelected =
        this.form.pagamentos[0]?.vencimento ||
        this.pagamento[0]?.vencimento ||
        this.thisDate();
      this.keyToReRender++;

      this.$nextTick(() => {
        this.applyingStoreForm = false;
      });
    },

    toggleTipoDesconto() {
      const novoTipo =
        this.form.desconto_tipo === "valor" ? "percentual" : "valor";

      this.form.desconto_tipo = novoTipo;
      this.form.desconto = 0;

      this.recalcularPagamentosPorDesconto();
      this.syncFormWithStore();

      this.keyToReRender++;
    },

    getTotalProdutosEServicos() {
      // soma o total dos serviços, se existirem
      const totalServicos = !_.isEmpty(this.store.formServicos)
        ? this.store.formServicos.reduce(
            (acc, s) => acc + Number(s.total || 0),
            0
          )
        : 0;

      // verifica se há produtos e soma o subtotal
      const hasProducts = !!this.store.formProduto?.produtos?.length;
      const totalProdutos = hasProducts
        ? Number(this.store.formProduto?.subtotal || 0)
        : 0;

      // retorna o total bruto (produtos + serviços)
      return totalServicos + totalProdutos;
    },

    calcularValorDesconto() {
      const total = this.getTotalProdutosEServicos();
      if (this.form.desconto_tipo === "percentual") {
        const perc = Number(this.form.desconto) || 0;
        return this.round((total * perc) / 100, 2);
      }
      return this.round(Number(this.form.desconto) || 0, 2);
    },

    // 🔧 AJUSTADO para respeitar valor digitado
    recalcularPagamentosPorDesconto() {
      const total = this.getTotalProdutosEServicos();
      const valorDesconto = this.calcularValorDesconto();

      if (this.hasNoProductsOrServices) {
        this.subtotal = 0;
        return;
      }

      // quanto falta considerando o que já foi pago
      const faltaPagar = this.round(total - valorDesconto - this.valorPago, 2);

      // se o usuário digitou um valor manual (ex.: 50) e ele é diferente do total,
      // vamos usar esse como base para montar as parcelas
      const usuarioDigitou =
        this.valorPagoARealizar &&
        this.valorPagoARealizar !== total &&
        this.valorPagoARealizar > 0;

      const baseParaParcelar = usuarioDigitou
        ? this.valorPagoARealizar
        : faltaPagar;

      this.subtotal = this.round(faltaPagar, 2);

      if (!this.formaPagamento) return;

      this.pagamento = this.calculateInstallments(
        this.formaPagamento,
        baseParaParcelar < 0 ? 0 : baseParaParcelar
      ).map((el) => ({
        vencimento: el.date,
        valor: el.value,
      }));

      this.vencimentoSelected = this.pagamento[0]?.vencimento;
    },

    removePagamento(pagamentoDeleted, indexToRemove) {
      this.form.pagamentos = this.form.pagamentos.filter(
        (p, idx) => idx !== indexToRemove
      );
      const total = this.getTotalProdutosEServicos();
      const valorDesconto = this.calcularValorDesconto();
      this.valorPago = this.form.pagamentos.reduce(
        (acc, p) => this.round(acc + p.valor, 2),
        0
      );
      this.subtotal = this.round(total - valorDesconto, 2);
      this.valorPagoARealizar = this.round(total, 2);
      this.syncFormWithStore();
    },

    changePagamento(index) {
      this.selectedPagamento = index;
    },

    changePagamentoEdited(valor) {
      this.pagamentoEditado = valor;
    },

    salvarPagamento() {
      this.pagamento[this.selectedPagamento].valor = this.pagamentoEditado;

      const editIdx = this.pagamentosEditados.findIndex(
        (p) => p?.index === this.selectedPagamento
      );
      if (editIdx === -1) {
        this.pagamentosEditados.push({
          index: this.selectedPagamento,
          value: this.pagamentoEditado,
        });
      } else {
        this.pagamentosEditados.splice(editIdx, 1, {
          index: this.selectedPagamento,
          value: this.pagamentoEditado,
        });
      }

      const totalEdited = this.pagamentosEditados.reduce((acc, p) => {
        return p?.value ? this.round(acc + p.value, 2) : acc;
      }, 0);

      const editedCount = this.pagamentosEditados.length;
      const restante = this.round(this.valorPagoARealizar - totalEdited, 2);
      const valorRestante =
        this.pagamento.length - editedCount > 0
          ? this.round(restante / (this.pagamento.length - editedCount), 2)
          : 0;

      this.pagamento = this.pagamento.map((item, idx) => {
        const edited = this.pagamentosEditados.find((p) => p.index === idx);
        return {
          ...item,
          valor: edited ? this.round(edited.value, 2) : valorRestante,
        };
      });

      this.$bvModal.hide("modal-pagamento");
    },

    selectVencimento(index) {
      this.indexVencimento = index;
    },

    salvarVencimento() {
      this.pagamento[this.indexVencimento].vencimento = this.vencimentoSelected;
      this.$bvModal.hide("modal-calendar");
    },

    clearInputs() {
      this.formaPagamento = null;
      this.informacoesAdicionais = "";
      this.planoConta = this.plano_contas.find(
        (plano) => plano.descricao === "Venda de Produtos"
      );
      this.valorPagoARealizar = this.round(this.getTotalProdutosEServicos(), 2);
      this.form.vencimento = this.thisDate();
      this.pagamento = [];
      this.pagamentosEditados = [];
    },

    // 🔧 AJUSTADO para usar o valor digitado
    addPagamento() {
      if (this.hasNoProductsOrServices) {
        return;
      }

      const total = this.getTotalProdutosEServicos();
      const valorDesconto = this.calcularValorDesconto();

      // valor que o usuário digitou no campo de cima
      const valorDigitado = Number(this.valorPagoARealizar) || 0;

      // se ele digitou um valor e esse valor é diferente do total,
      // usa o valor digitado; senão, usa o restante
      const valorBase =
        valorDigitado > 0 && valorDigitado !== total
          ? valorDigitado
          : total - valorDesconto - this.valorPago;

      const valorFinal = this.round(valorBase < 0 ? 0 : valorBase, 2);

      this.form.pagamentos = [
        ...this.form.pagamentos,
        {
          forma_pagamento: this.formaPagamento,
          valor: valorFinal,
          vencimento: this.form.vencimento,
          range: this.pagamento.map((p) => ({
            value: this.round(p.valor, 2),
            date: moment(p.vencimento).format("YYYY-MM-DD"),
          })),
        },
      ];

      this.valorPago = this.form.pagamentos.reduce(
        (acc, p) => this.round(acc + p.valor, 2),
        0
      );
      this.subtotal = this.round(total - valorDesconto - this.valorPago, 2);
      this.valorPagoARealizar = this.round(this.subtotal, 2);
      this.keyToReRender++;
    },

    onSearchFormaPagamentos(search, loading) {
      if (search.length) {
        loading(true);
        this.searchFormaPagamentos(search, loading, this);
      } else {
        this.formas_pagamento = this.formasPagamentoArray;
      }
    },

    onInputValue(valor) {
      this.changePagamentoValue(valor, this);
    },

    changePagamentoValue: _.debounce((valor, vm) => {
      vm.valorPagoARealizar = vm.round(valor, 2);

      // se não tem produto/serviço, só sincroniza e sai
      if (vm.hasNoProductsOrServices) {
        vm.syncFormWithStore();
        return;
      }

      if (valor === 0) {
        vm.recalcularPagamentosPorDesconto();
        vm.syncFormWithStore();
        return;
      }
      vm.pagamento = vm
        .calculateInstallments(vm.formaPagamento, valor)
        .map((el) => ({
          vencimento: el.date,
          valor: el.value,
        }));
      vm.vencimentoSelected = vm.pagamento[0]?.vencimento;
      vm.valorError = false;
      vm.valorFilled = true;
      vm.recalcularPagamentosPorDesconto();
      vm.syncFormWithStore();
    }, 800),

    resetPayment() {
      this.form.pagamentos = [];
      this.valorPago = 0;
      this.atualizarTotaisPreservandoPagamentos();
      this.keyToReRender++;
      this.syncFormWithStore();
    },

    atualizarTotaisPreservandoPagamentos() {
      if (
        (!this.form.pagamentos || this.form.pagamentos.length === 0) &&
        this.temPagamentosNaStore()
      ) {
        this.aplicarFormPagamentosDaStore(this.store.formPagamentos);
        return;
      }

      const total = this.getTotalProdutosEServicos();
      const valorDesconto = this.calcularValorDesconto();
      this.valorPago = (this.form.pagamentos || []).reduce(
        (acc, p) => this.round(acc + Number(p.valor || 0), 2),
        0
      );
      this.subtotal = this.round(total - valorDesconto - this.valorPago, 2);
      this.valorPagoARealizar = this.round(
        this.subtotal > 0 ? this.subtotal : 0,
        2
      );
    },

    setFormaPagamento(forma_pagamento) {
      const total = this.getTotalProdutosEServicos();
      const valorDesconto = this.calcularValorDesconto();
      const aPagar = total - valorDesconto - this.valorPago;

      // se não tem produto/serviço, só seta e sai
      if (this.hasNoProductsOrServices) {
        this.formaPagamento = forma_pagamento;
        this.pagamentoError = false;
        this.pagamentoFilled = true;
        this.pagamentosEditados = [];
        return;
      }

      // se o usuário digitou um valor manual, respeita ele
      const usuarioDigitou =
        this.valorPagoARealizar &&
        this.valorPagoARealizar !== total &&
        this.valorPagoARealizar > 0;

      const base = usuarioDigitou ? this.valorPagoARealizar : aPagar;

      this.pagamento = this.calculateInstallments(
        forma_pagamento,
        base < 0 ? 0 : base
      ).map((el) => ({
        vencimento: el.date,
        valor: el.value,
      }));
      this.vencimentoSelected = this.pagamento[0]?.vencimento;
      this.formaPagamento = forma_pagamento;
      this.pagamentoError = false;
      this.pagamentoFilled = true;
      this.pagamentosEditados = [];
    },

    searchFormaPagamentos: _.debounce(async (search, loading, vm) => {
      vm.formas_pagamento = vm.formasPagamentoArray.filter((item) =>
        item.descricao.toLowerCase().includes(search.toLowerCase())
      );
      loading(false);
    }, 350),
  },
  created() {
    this.getDataInit();
    if (Object.keys(this.$route.params).length !== 0) {
      const { pagamentos, desconto, desconto_tipo } = this.$route.params.osData;
      this.fromEdit = true;
      this.form.pagamentos = (pagamentos || []).map((p) => ({
        forma_pagamento: p.forma_pagamento,
        valor: p.valor,
        vencimento: p.range?.[0]?.date ?? null,
        range: p.range,
      }));

      this.form.desconto_tipo = desconto_tipo || "valor";
      if (this.form.desconto_tipo === "percentual") {
        const total = this.getTotalProdutosEServicos();
        this.form.desconto = total > 0 ? (desconto / total) * 100 : 0;
      } else {
        this.form.desconto = desconto ?? 0;
      }

      this.valorPago = this.form.pagamentos.reduce(
        (acc, p) => acc + p.valor,
        0
      );
      this.recalcularPagamentosPorDesconto();
      this.syncFormWithStore();
      this.keyToReRender++;
    }
  },
  watch: {
    "store.formProduto": {
      handler() {
        if (!this.fromEdit) {
          this.atualizarTotaisPreservandoPagamentos();
          this.recalcularPagamentosPorDesconto();
          this.syncFormWithStore();
        } else {
          if (!this.store.dataFetching.produtos) {
            this.atualizarTotaisPreservandoPagamentos();
            this.syncFormWithStore();
          }
          this.store.dataFetching.produtos = false;
        }
      },
      deep: true,
    },
    "store.formServicos": {
      handler() {
        if (!this.fromEdit) {
          this.atualizarTotaisPreservandoPagamentos();
          this.recalcularPagamentosPorDesconto();
          this.syncFormWithStore();
        } else {
          if (!this.store.dataFetching.servicos) {
            this.atualizarTotaisPreservandoPagamentos();
            this.syncFormWithStore();
          }
          this.store.dataFetching.servicos = false;
        }
      },
      deep: true,
    },
    "form.desconto"() {
      this.recalcularPagamentosPorDesconto();
      this.syncFormWithStore();
    },
    "form.desconto_tipo"() {
      this.recalcularPagamentosPorDesconto();
      this.syncFormWithStore();
    },
    valorPagoARealizar() {
      this.recalcularPagamentosPorDesconto();
      this.syncFormWithStore();
    },
    "store.formPagamentos": {
      handler(newValue) {
        if (!newValue || _.isEmpty(newValue) || _.isEqual(newValue, this.form)) {
          return;
        }

        this.aplicarFormPagamentosDaStore(newValue);
      },
      deep: true,
    },
    "store.formPagamentos.pagamentos"(newValue) {
      const total = this.getTotalProdutosEServicos();
      const valorDesconto = this.calcularValorDesconto();

      if (this.hasNoProductsOrServices) {
        this.subtotal = 0;
        this.valorPago = 0;
        return;
      }

      this.valorPago = newValue.reduce((acc, p) => this.round(acc + p.valor, 2), 0);
      this.subtotal = this.round(total - valorDesconto - this.valorPago, 2);
    },
    "store.currentTab"(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.syncFormWithStore();
      }

      // indo pra próxima etapa
      if (newValue !== oldValue && newValue === 6 && oldValue < newValue) {
        if (this.hasNoProductsOrServices) {
          return;
        }

        this.$v.form.$touch();

        if (this.$v.form.$anyError) {
          if (this.$v.form.$anyError)
            this.$toast.error("Necessário incluir pagamento");
          this.store.currentTab = oldValue;
          return;
        }

        if (this.pagamento.length === 0 && this.$v.form.$anyError) {
          this.$toast.error("Necessário incluir valor do pagamento");
          this.valorError = true;
        }
        if (!this.formaPagamento && this.$v.form.$anyError) {
          this.$toast.error("Necessário incluir forma de pagamento");
          this.pagamentoError = true;
        }
        if (!this.planoConta && this.$v.form.$anyError) {
          this.$toast.error("Necessário incluir plano de contas");
          this.planoContasError = true;
        }
      }
    },
    "form.pagamentos": {
      handler() {
        this.syncFormWithStore();
      },
      deep: true,
    },
  },
  computed: {
    ...mapGetters([
      "isAuthenticated",
      "breadcrumbs",
      "pageTitle",
      "layoutConfig",
    ]),
    ...mapState(["loading"]),
    isLoading() {
      return this.loading.loading;
    },
    hasNoProductsOrServices() {
      const hasServices = !!this.store.formServicos?.length;
      const hasProducts = !!this.store.formProduto?.produtos?.length;
      return !hasServices && !hasProducts;
    },
    isAllInputsNotFull() {
      if (this.hasNoProductsOrServices) {
        return false;
      }

      return (
        this.valorPagoARealizar === 0 ||
        !this.formaPagamento ||
        !this.planoConta
      );
    },
    valorPagamento() {
      return this.pagamento.length === 0 ? 0 : this.pagamento[0].valor;
    },
    isTheCurrentTab() {
      return store.currentTab === 5;
    },
  },
};
</script>

<style>
.hasErrors .vs__dropdown-toggle {
  border: 2px solid red;
}
.hasErrors .vs__clear,
.hasErrors .vs__open-indicator {
  fill: red;
}
.inputFilled .vs__dropdown-toggle {
  border: 2px solid #1bc5bd;
}
.inputFilled .vs__clear,
.inputFilled .vs__open-indicator {
  fill: #1bc5bd;
}
</style>
